import { PALETTE } from '../../common/styles/palette';

export const styles = (theme: any) => {
    return {
        RoomDetailContainer: {
            padding: 10,
        },
        ButtonTextSizeSmall:{
            fontSize: '10px'
        },
        ClosingDaysTitle: {
            display: 'flex',
            alignItems: 'center'
        },
        ClosingDaysLabel: {
            paddingRight: 30,
            marginTop: 20
        },
        ClosingDayPickerContainer: {
            display: 'flex'
        },
        ClosingDayDeleteIcon: {
            marginTop: 24
        },
        ClosingDaysListContainer: {
            display: 'block'
        },
        SearchContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        searchButtons: {
            width: '100%',
            paddingLeft: '10px',
            display: 'flex',
            justifyContent: "flex-end"
        },
        searchButton: {
            display: 'flex',
            justifyContent: "flex-end",
            alignItems: 'center',
            marginLeft: '10px',
            marginRight: '10px',
        },
        SearchSection: {
            display: 'flex',
            justifyContent: "flex-end",
            alignItems: 'center'
        },
        room: {

        },
        roomSelected: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor
        },
        detailSample: {
            display: 'flex',
            padding: '5px',
            alignContent: 'center',
            margin: '10px'
        },
        detailSampleText: {
            paddingLeft: '20px',
        },
        textColorRadioGroup: {
            paddingLeft: '10px',
            border: '1px solid black',
            width: 'fit-content'
        },
        colorSection: {
            marginTop: '20px'
        },
        colorSectionItem: {
            marginTop: '10px'
        },
        detailButtonsContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '0px 10px 10px 0px'
        },
        tableHeader: {
            backgroundColor: PALETTE.UI.TablesHeader.BackgroundColor,
            display: 'flex',
            alignItems: 'center',
            paddingTop: '2px',
            paddingBottom: '2px',
            paddingLeft: '10px',
            paddingRight: '10px',
        },
        table: {
            display: 'flex',
            alignItems: 'center',
            paddingTop: '2px',
            paddingBottom: '2px',
            paddingLeft: '10px',
            paddingRight: '10px',
        },
        tableHeaderCell: {
            display: 'flex',
            alignItems: 'center',
        },
        detailHeaderText: {
            paddingLeft: '0px'
        },
        roomIcon: {
            minWidth: '0px',
            paddingRight: '10px'
        }
    }
}